
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.083 9.333v-7m0 0L1.75 4.667m2.333-2.334l2.334 2.334m3.5 0v7m0 0l2.333-2.334m-2.333 2.334L7.583 9.333","stroke":"#484848","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    